var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Checkbox } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import without from 'lodash/without';
import { PureComponent } from 'react';
import { change } from 'redux-form';
import styles from './categorizedMultiSelectCategoryItem.module.scss';
export class CategorizedMultiSelectCategoryItem extends PureComponent {
    isChecked() {
        return this.props.input.value.indexOf(this.props.item.value) !== -1;
    }
    selectItem() {
        const { meta, input, readOnly } = this.props;
        if (readOnly)
            return;
        const { form: formName, dispatch } = meta;
        const { name, value } = input;
        const shouldUncheck = this.isChecked();
        const newValue = shouldUncheck
            ? without(value, this.props.item.value)
            : value.concat([this.props.item.value]);
        dispatch(change(formName, name, newValue));
    }
    render() {
        const { item, disabled, readOnly } = this.props;
        const isChecked = this.isChecked();
        const rootClass = classnames({
            [styles.root]: styles.root,
            [styles.rootDisabled]: disabled,
            [styles.rootReadOnly]: readOnly,
            [styles.rootChecked]: isChecked,
        });
        return (_jsxs("label", Object.assign({ className: rootClass, htmlFor: item.name }, { children: [_jsx(Checkbox, { checked: isChecked, name: item.name, id: item.name, onChange: this.selectItem, className: styles.checkbox, disabled: disabled }), _jsx("div", Object.assign({ className: styles.icon }, { children: _jsx(DixaIcon, { icon: item.icon }) })), _jsx("div", Object.assign({ className: styles.name }, { children: item.name }))] }), item.name));
    }
}
__decorate([
    boundMethod
], CategorizedMultiSelectCategoryItem.prototype, "selectItem", null);
